<div class="wrap" *ngIf="location">
  <div class="top">
    <div class="header">
      {{
        isInstoreMode
          ? ("@components.header.instoreTitle" | translate)
          : ("@components.header.deliverToTitle" | translate)
      }}
    </div>
    <!-- <app-svg-icon class="icon" [name]="'down'"></app-svg-icon> -->
  </div>
  <div class="bottom">
    <div class="destination-name">
      {{ location.name || "n/a" }}
    </div>
  </div>
</div>
